module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-agency-cascade-sent-9c81cbe0d4e0bb61af6d8bee6a708ca0.svg";